import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";
import StudyCard, { StudyCardData } from "./StudyCard";

interface StudyCardGridProps {
  studies: StudyCardData[];
  onCardClick: (study: StudyCardData) => void;
  loading?: boolean;
}

const MotionGrid = motion.create(Grid);

const StudyCardGrid: React.FC<StudyCardGridProps> = ({ studies, onCardClick, loading }) => {
  const shouldReduceMotion = useReducedMotion();

  if (!loading && studies.length === 0) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", flex: 1, minHeight: 200 }}>
        <Typography color="text.secondary">No studies match your filters.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ flex: 1, overflow: "auto", py: 1, px: 0.5 }}>
      <Grid container spacing={2}>
        <AnimatePresence mode="popLayout">
          {studies.map((study, index) => (
            <MotionGrid
              item
              xs={12}
              sm={6}
              md={4}
              key={study.study_id}
              layout={!shouldReduceMotion}
              initial={shouldReduceMotion ? false : { opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={shouldReduceMotion ? undefined : { opacity: 0, scale: 0.95 }}
              transition={{
                duration: shouldReduceMotion ? 0 : 0.2,
                delay: shouldReduceMotion ? 0 : index * 0.03,
              }}
            >
              <StudyCard study={study} onClick={onCardClick} />
            </MotionGrid>
          ))}
        </AnimatePresence>
      </Grid>
    </Box>
  );
};

export default StudyCardGrid;
